import React, { Fragment, useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import OwlCarousel from "react-owl-carousel";
import { Modal } from "react-bootstrap";
import { apiData } from "../../../../actions";
import DataLoader from "../../../../Utils/DataLoader";

const carouselOptions = {
  items: 4,
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  slidesToScroll: 3,
  autoplayHoverPause: true,
  nav: true,
  dots: false,
  responsive: {
    0: { items: 1 },
    768: { items: 2 },
    992: { items: 4 },
  },
};

const formatTitle = (title = "") =>
  title.length >= 25 ? `${title.slice(0, 47)}..` : title;

function AdrenalineRush() {
  const place = useSelector((state) => state.place);
  const formattedPlace = place.replace(/\b\w/g, (x) => x.toUpperCase());

  const [adrenalineData, setAdrenalineData] = useState([]);
  const [allAdrenalineData, setAllAdrenalineData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [seeMoreModal, setSeeMoreModal] = useState(false);

  const buildPayload = useCallback(
    (limit = 10) => ({
      city: place ? formattedPlace : "Chicago",
      keyword: "tour",
      limit: limit,
    }),
    [place, formattedPlace]
  );

  const fetchAdrenalineData = useCallback(async (limit = 10) => {
    setLoader(true);
    try {
      const res = await apiData.getAdrenalineRush(buildPayload(limit));
      const resultList = res?.data?.data?.data?.products?.resultList || [];
      setAdrenalineData(resultList);
      return res;
    } catch (error) {
      console.error("Error fetching adrenaline rush data:", error);
      setAdrenalineData([]);
      return null;
    } finally {
      setLoader(false);
    }
  }, [buildPayload]);

  const handleSeeAllClick = async () => {
    setSeeMoreModal(true);
    setLoader(true);

    try {
      // Step 1: Initial fetch to get totalCount
      const initialRes = await apiData.getAdrenalineRush(buildPayload(null));
      const totalCount = initialRes?.data?.data?.data?.products?.totalCount;

      if (totalCount === 0) {
        setAllAdrenalineData([]);
        return;
      }

      // Step 2: Fetch full data with totalCount as limit
      const fullRes = await apiData.getAdrenalineRush(buildPayload(totalCount));
      const resultList = fullRes?.data?.data?.data?.products?.resultList || [];

      let finalList = [];

      if (place) {
        finalList = resultList.filter(
          (item) => item?.customLabel3?.toLowerCase() === place.toLowerCase()
        );
      } else {
        finalList = resultList;
      }

      setAllAdrenalineData(finalList);
    } catch (err) {
      console.error("Error fetching all adrenaline data", err);
      setAllAdrenalineData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAdrenalineData();
  }, [fetchAdrenalineData]);

  return (
    <Fragment>
      <div className="flight-sec exitment-sec">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="slider-sec">
                <h2>Excitement-seeking</h2>
                <p>
                  Welcome to the world of excitement-seeking! Whether it's the
                  thrill of the unknown, heart-pounding adventures, or
                  electrifying experiences, get ready to satisfy your craving
                  for excitement and stimulation.
                </p>

                {adrenalineData.length > 0 ? (
                  <>
                    <OwlCarousel {...carouselOptions}>
                      {adrenalineData.map((ele, index) => (
                        <div
                          key={index}
                          data-aos="zoom-in-right"
                          className="slider-main"
                        >
                          <div className="slider-block">
                            <a href={ele.link} target="_blank" rel="noreferrer">
                              <img
                                loading="lazy"
                                src={ele.imageLink}
                                alt={ele.title}
                              />
                            </a>
                            <div className="slider-content allExcitementSeekingHead">
                              <h3>{formatTitle(ele.title)}</h3>
                              <div className="d-flex flex-column gap-2">
                                <span className="allExcitementSeekingDescription">{formatTitle(ele.description)}</span>
                                <span className="allExcitementSeekingPrice d-flex gap-1">{`$ ${ele.price.amount}`}
                                  <div className="escape-room">
                                    <p className="time-formate allExcitementSeekingTimeFormate">
                                      <img src="/images/location.svg" alt="" />
                                      {ele.customLabel3 || formattedPlace}
                                    </p>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </OwlCarousel>
                    <div className="m-4 view-tag clickable">
                      <a onClick={handleSeeAllClick} className="m-4">
                        See All
                      </a>
                    </div>
                  </>
                ) : (
                  <p>
                    Oops! No Data Available{" "}
                    <strong>For {formattedPlace}</strong>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={seeMoreModal}
        onHide={() => setSeeMoreModal(false)}
        centered
        className='modal_xl see-pop'
        size="xxl"
      >
        <Modal.Header closeButton>
          <Modal.Title>All Excitement-seeking Activities</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {loader ? (
              <div className="text-center my-4 w-100">
                <DataLoader />
              </div>
            ) : allAdrenalineData.length > 0 ? (
              allAdrenalineData.map((ele, index) => (
                <div key={index} className="col-md-3 mb-4">
                  <div className="slider-block">
                    <a href={ele.link} target="_blank" rel="noreferrer">
                      <img loading="lazy" src={ele.imageLink} alt={ele.title} />
                    </a>
                    <div className="slider-content allExcitementSeekingHead">
                      <h3>{formatTitle(ele.title)}</h3>
                      <div className="d-flex flex-column gap-2">
                        <span className="allExcitementSeekingDescription">{formatTitle(ele.description)}</span>
                        <span className="allExcitementSeekingPrice d-flex gap-1">{`$ ${ele.price.amount}`}
                          <div className="escape-room">
                            <p className="time-formate allExcitementSeekingTimeFormate">
                              <img src="/images/location.svg" alt="" />
                              {ele.customLabel3 || formattedPlace}
                            </p>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No Data Found</p>
            )}
          </div>
        </Modal.Body>
      </Modal>


    </Fragment>
  );
}
export default AdrenalineRush;
